"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Object representing dto for sending only partial of {@Link PriceComment comment}
 *
 * @author JMr
 */


var PriceCommentSaveRequest =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PriceCommentSaveRequest, _DomainObject_1$Domai);

  /**
   * PriceCommentSaveRequest
   *
   * @param priceZoneId
   * @param text
   * @param persistent boolean indicating persistence of comment
   * @param deleteOn validity date
   */
  function PriceCommentSaveRequest(priceZoneId, text, persistent, deleteOn) {
    var _this;

    _classCallCheck(this, PriceCommentSaveRequest);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceCommentSaveRequest).call(this));
    _this.priceZoneId = priceZoneId;
    _this.text = text;
    _this.persistent = persistent;
    _this.deleteOn = deleteOn;
    return _this;
  }

  return PriceCommentSaveRequest;
}(DomainObject_1.DomainObject);

exports.PriceCommentSaveRequest = PriceCommentSaveRequest;

PriceCommentSaveRequest.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PriceCommentSaveRequest.name);
  return {
    priceZoneId: builder.str('priceZoneId'),
    text: builder.str('text'),
    persistent: builder.opt(builder.bool('persistent')),
    deleteOn: builder.opt(builder.date('deleteOn', DateParser_1.DateParser.ISO_PATTERN))
  };
}();